import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type storeDeleteState = {
  storeDeleteState: boolean;
};

const initialState: storeDeleteState = {
  storeDeleteState: false,
};

export const storeDeleteStateSlice = createSlice({
  name: "storeDeleteState",
  initialState,
  reducers: {
    setStoreDeleteState: (state, action: PayloadAction<boolean>) => {
      state.storeDeleteState = action.payload;
    },
  },
});

export const { setStoreDeleteState } = storeDeleteStateSlice.actions;

export default storeDeleteStateSlice.reducer;
